import { Avatar, Box, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, Grid } from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import StatCard from '../../../components/StatCard';
import PageHeader from '../../../components/common/PageHeader';


function ESET() {
    
    const [history, setHistory] = useState([]);
    const [esetLicenses, setEsetLicenses] = useState([]);
    
       const fetchEsetLicenses = async () => {
           try {
               const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/eset/licenses`);
               setEsetLicenses(response.data);
    
           } catch (error) {
               console.error('Error fetching licenses:', error);
           }
       };
    
    
    const fetchHistory = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/history`);
            setHistory(
                response.data
                    .filter((eset) => eset.entity === "eset")
                    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
            );
        } catch (error) {
            console.error('Error fetching organizations:', error);
        }
    };
  
    
  
    useEffect(() => {
        fetchHistory();
        fetchEsetLicenses();
    }, []);
 
    return (
        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
           <PageHeader section="Infrastructure" title="ESET" sx={{ mb: 2 }} />
          <Box>
             <Grid container spacing={3}>
                <Grid item size={{ xs: 12, md: 3 }}>
                    <StatCard icon={<Avatar sx={{bgcolor:'#d32f2f'}}><ReportIcon/></Avatar>}  bgColor={esetLicenses.filter(license => license.used > license.quantity).length > 0 && '#ffebee'} borderColor={esetLicenses.filter(license => license.used > license.quantity).length > 0  && '1px solid #d32f2f'} title={"Licenses surconsommées"} value={esetLicenses.filter(license => license.used > license.quantity).length} />
                </Grid>
            </Grid>
             {/* <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card sx={{ backgroundColor: '#ffebee', border: '1px solid #d32f2f' }}>
                       <CardContent>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Box sx={{ display                      : 'flex', alignItems: 'center' }}>
                                    <Typography variant="h6"> Overused licenses</Typography>&nbsp;
                                    <ReportIcon/>
                              </Box>
                          </Box>
                          <Typography variant="h4" sx={{ color: '#d32f2f' }}>
                             {esetLicenses.filter(license => license.used > license.quantity).length}
                          </Typography>
                       </CardContent>
                    </Card>
                </Grid>
             </Grid> */}
             <Box sx={{ mt: 4 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Overused licenses details
                </Typography>
                <Card>

                <TableContainer>
                    <Table size="small">
                       <TableHead>
                            <TableRow>
                                <TableCell>Clé de Licence</TableCell>
                                <TableCell>Nom</TableCell>
                                <TableCell>Utilisé</TableCell>
                                <TableCell>Total</TableCell>
                                <TableCell>Organisation</TableCell>
                                <TableCell>Surutilisation</TableCell>
                            </TableRow>
                       </TableHead>
                       <TableBody>
                    {esetLicenses
                        .filter(license => license.used > license.quantity)
                        .map((license, index) => (
                        <TableRow key={index}>
                            <TableCell>{license.licenseKey}</TableCell>
                            <TableCell>{license.name}</TableCell>
                            <TableCell>{license.used}</TableCell>
                            <TableCell>{license.quantity}</TableCell>
                            <TableCell>{license.organizationDetails?.name || 'Non associe'}</TableCell>
                            <TableCell><Chip label={`+${license.used - license.quantity}`} color='error' /></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                    </Table>
                </TableContainer>
                </Card>
             </Box>
             <Box sx={{ mt: 4 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    License history
                </Typography>
             <Card>

                <TableContainer>
                    <Table size="small">
                       <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Entité</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Action</TableCell>
                                <TableCell>Quantité</TableCell>
                                <TableCell>Quantité Avant</TableCell>
                                <TableCell>Quantité Après</TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Détails</TableCell>
                            </TableRow>
                       </TableHead>
                       <TableBody>
                    {history
                        .filter((item) => item.entitySubType === "esetLicense" || item.logType?.includes("usage"))
                        .map((item) => (
                        <TableRow key={item._id}>
                            <TableCell>{new Date(item.timestamp).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })} {new Date(item.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</TableCell>
                            <TableCell>Licence ESET</TableCell>
                            <TableCell>
                                {item.entityType === "used" ? "Utilisation" : item.entityType === "total" ? "Total" : item.entityType}
                            </TableCell>
                            <TableCell>
                                {item.action === "added" ? "Ajout" : item.action === "removed" ? "Suppression" : item.action}
                            </TableCell>
                            <TableCell>
                                <Chip
                                    label={item.quantityDiff > 0 ? `+${item.quantityDiff}` : item.quantityDiff}
                                    color={item.quantityDiff > 0 ? "success" : "error"}
                                />
                            </TableCell>
                            <TableCell>{item.quantityBefore}</TableCell>
                            <TableCell>{item.quantityAfter}</TableCell>
                            <TableCell>{item.organizationDetails?.name || 'Non associe'}</TableCell>
                            <TableCell>{item.details?.additionalInfo?.licenseKey || '-'}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                    </Table>
                </TableContainer>
                </Card>
             </Box>

             <Box sx={{ mt: 4 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Devices history
                </Typography>
                <Card>

                <TableContainer>
                    <Table size="small">
                       <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Entité</TableCell>
                                <TableCell>Quantité</TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Détails</TableCell>
                            </TableRow>
                       </TableHead>
                       <TableBody>
                    {history
                        .filter((item) => item.entitySubType === "esetDevice" || item.logType?.includes("device"))
                        .map((item) => (
                        <TableRow key={item._id}>
                            <TableCell>{new Date(item.timestamp).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' })} {new Date(item.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</TableCell>
                            <TableCell>Appareil ESET</TableCell>
                            <TableCell>
                                <Chip
                                    label={item.quantityDiff > 0 ? `+${item.quantityDiff}` : item.quantityDiff}
                                    color={item.quantityDiff > 0 ? "success" : "error"}
                                />
                            </TableCell>
                            <TableCell>{item.organizationDetails?.name || 'Non associe'}</TableCell>
                            <TableCell>{item.details?.additionalInfo?.name || '-'}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                    </Table>
                </TableContainer>
             </Card>
             </Box>

          </Box>
        </Box>
    );
 }

export default ESET
